import React from "react";
import GenericForm, { FormFieldConfig } from "../../../../../../../shared/components/genericform/GenericForm";

interface CustomerDetailsDialogProps {
  open: boolean;
  onClose: () => void;
  customerName: string;
  customerPhone: string;
  onCustomerNameChange: (name: string) => void;
  onCustomerPhoneChange: (phone: string) => void;
  onSaveCustomer: () => void;
}

const CustomerDetailsDialog: React.FC<CustomerDetailsDialogProps> = ({ open, onClose, customerName, customerPhone, onCustomerNameChange, onCustomerPhoneChange, onSaveCustomer }) => {  const handlePhoneChange = (value: string) => {
    const numericValue = value.replace(/\D/g, ""); 
    if (numericValue.length <= 8) {
      onCustomerPhoneChange(numericValue);
    }
  };

  const fields: FormFieldConfig[] = [
    {
      id: "customerName",
      label: "Customer Name",
      required: true,
      type: "text",
      value: customerName,
      onChange: onCustomerNameChange,
    },
    {
      id: "customerPhone",
      label: "Customer Phone Number",
      required: true,
      type: "text", 
      value: customerPhone,
      onChange: handlePhoneChange,
    },
  ];

  const isFormValid = () => {
    const trimmedName = customerName.trim();
    return trimmedName !== "" && customerPhone.length === 8;
  };

  const handleClose = () => {
    onCustomerNameChange("");
    onCustomerPhoneChange("");
    onClose();
  };

  return (
    <GenericForm open={open} title="Enter Customer Details" fields={fields} onClose={handleClose} onSubmit={onSaveCustomer} isFormValid={isFormValid} confirmLabel="Confirm" cancelLabel="Cancel" />
  );
};

export default CustomerDetailsDialog;
